export default __webpack_public_path__ + "static/media/uttu.8589eca2.png";